export enum DesignProjectCategoryId {
    BarCounter = 'BarCounter',
    BarRestaurant = 'BarRestaurant',
    BathRoom = 'BathRoom',
    Bedding = 'Bedding',
    BedRoom = 'BedRoom',
    Counter = 'Counter',
    Decoration = 'Decoration',
    DeskAndTable = 'DeskAndTable',
    DisplayCase = 'DisplayCase',
    DisplayCaseRefrigered = 'DisplayCaseRefrigered',
    Event = 'Event',
    GreenWall = 'GreenWall',
    Ground = 'Ground',
    HotelRoomFurniture = 'HotelRoomFurniture',
    Kitchen = 'Kitchen',
    Lights = 'Lights',
    LightsAndDeco = 'LightsAndDeco',
    LivingRoom = 'LivingRoom',
    LobbyLounge = 'LobbyLounge',
    OfficeFurniture = 'OfficeFurniture',
    OfficeWorkSpace = 'OfficeWorkSpace',
    Outside = 'Outside',
    PartitionAndAcoustics = 'PartitionAndAcoustics',
    PhoneBooth = 'PhoneBooth',
    ReceptionFurniture = 'ReceptionFurniture',
    RemovablePartition = 'RemovablePartition',
    RestaurantTable = 'restaurantTable',
    Seated = 'Seated',
    ShopFurniture = 'ShopFurniture',
    ShowCaseLight = 'ShowCaseLight',
    StorageUnit = 'StorageUnit',
    Table = 'Table',
    Teaches = 'Teaches',
    TerraceFurniture = 'TerraceFurniture',
}

export enum DesignProjectId {
    AcousticPanel = 'AcousticPanel',
    Armchair = 'Armchair',
    ArmorWardrobe = 'ArmorWardrobe',
    Awning = 'Awning',
    BarChair = 'BarChair',
    BarStool = 'BarStool',
    Bedding = 'Bedding',
    Bedhead = 'Bedhead',
    Bedspring = 'Bedspring',
    BeenBag = 'BeenBag',
    Bench = 'Bench',
    BenchLong = 'BenchLong',
    Bind = 'Bind',
    BindBottle = 'BindBottle',
    BistroTable = 'BistroTable',
    BottleDisplay = 'BottleDisplay',
    Buffet = 'Buffet',
    BunkBed = 'BunkBed',
    ButchersBlock = 'ButchersBlock',
    CabinBed = 'CabinBed',
    Carpet = 'Carpet',
    CeilingLight = 'CeilingLight',
    CentralCounter = 'CentralCounter',
    CentralDressingTable = 'CentralDressingTable',
    Chair = 'Chair',
    Chandelier = 'Chandelier',
    ClassicBed = 'ClassicBed',
    CompleteStaircase = 'CompleteStaircase',
    ConferenceTable = 'ConferenceTable',
    Console = 'Console',
    CornerCounter = 'CornerCounter',
    CounterRight = 'CounterRight',
    CoworkingTable = 'CoworkingTable',
    Cupboard = 'Cupboard',
    CurtainsAndNetCurtains = 'CurtainsAndNetCurtains',
    CuttingStool = 'CuttingStool',
    Desert = 'Desert',
    Desk = 'Desk',
    DinnerTable = 'DinnerTable',
    DisplayCaseBakery = 'DisplayCaseBakery',
    DisplayCaseButchery = 'DisplayCaseButchery',
    DisplayCaseCheese = 'DisplayCaseCheese',
    DisplayCaseIceCream = 'DisplayCaseIceCream',
    DisplayCasePositiveTemperature = 'DisplayCasePositiveTemperature',
    DisplayCaseSandwichShop = 'DisplayCaseSandwichShop',
    Door = 'Door',
    Dresser = 'Dresser',
    DressingRoom = 'DressingRoom',
    EatStandingUp = 'EatStandingUp',
    Equippedkitchen = 'Equippedkitchen',
    ExecutiveDesk = 'ExecutiveDesk',
    Fence = 'Fence',
    GlassShowerScreen = 'GlassShowerScreen',
    GlassWall = 'GlassWall',
    GreenWall = 'GreenWall',
    GroundMattress = 'GroundMattress',
    HeightAdjustableDesk = 'HeightAdjustableDesk',
    HighChair = 'HighChair',
    HighTable = 'HighTable',
    InduvidualDesk = 'InduvidualDesk',
    Laboratory = 'Laboratory',
    LEDStrip = 'LEDStrip',
    Library = 'Library',
    LightFixture = 'LightFixture',
    LowTable = 'LowTable',
    ManicureTable = 'ManicureTable',
    Marquise = 'Marquise',
    MeetingTable = 'MeetingTable',
    MetalCabinet = 'MetalCabinet',
    MetalicWardrobe = 'MetalicWardrobe',
    MetalSign = 'MetalSign',
    MezzanineBed = 'MezzanineBed',
    Mirror = 'Mirror',
    MobileBoxes = 'MobileBoxes',
    NeonSign = 'NeonSign',
    NightStand = 'NightStand',
    OfficeChair = 'OfficeChair',
    OfficeDivider = 'OfficeDivider',
    OutdoorChair = 'OutdoorChair',
    OutdoorTable = 'OutdoorTable',
    Panetiere = 'Panetiere',
    ParquetFloor = 'ParquetFloor',
    ParquetFloorBathRoom = 'ParquetFloorBathRoom',
    ParquetFloorBedRoom = 'ParquetFloorBedRoom',
    ParquetFloorHouseInterior = 'ParquetFloorHouseInterior',
    ParquetFloorKitchen = 'ParquetFloorKitchen',
    ParquetFloorLobyLounge = 'ParquetFloorLobyLounge',
    ParquetFloorRestaurant = 'ParquetFloorRestaurant',
    ParquetFloorRoom = 'ParquetFloorRoom',
    PartitionPanel = 'PartitionPanel',
    PartitionSeparation = 'PartitionSeparation',
    Pergola = 'Pergola',
    PhoneBooth = 'PhoneBooth',
    Portal = 'Portal',
    PresentationTable = 'PresentationTable',
    ProductDisplay = 'ProductDisplay',
    ReceptionBenches = 'ReceptionBenches',
    ReceptionChairs = 'ReceptionChairs',
    ReceptionCounter = 'ReceptionCounter',
    ReceptionDesk = 'receptionDesk',
    RecessedSpot = 'RecessedSpot',
    RefrigeratedDisplay = 'RefrigeratedDisplay',
    RemovablePartition = 'RemovablePartition',
    RoundedCounter = 'RoundedCounter',
    SalesTable = 'SalesTable',
    SelfServiceDisplayCase = 'SelfServiceDisplayCase',
    Separator = 'Separator',
    Shelving = 'Shelving',
    ShoesCabinet = 'ShoesCabinet',
    ShowCase = 'ShowCase',
    ShowCaseLight = 'ShowCaseLight',
    Sideboard = 'Sideboard',
    Sofa = 'Sofa',
    StairRailing = 'StairRailing',
    Stairs = 'Stairs',
    Stand = 'Stand',
    Stool = 'Stool',
    StorageUnit = 'StorageUnit',
    StreetLamp = 'StreetLamp',
    StylingChair = 'StylingChair',
    SummerKitchen = 'SummerKitchen',
    Sunbath = 'Sunbath',
    SwimmingPool = 'SwimmingPool',
    Table = 'Table',
    TiledFloor = 'TiledFloor',
    TiledFloorBathRoom = 'TiledFloorBathRoom',
    TiledFloorBedRoom = 'TiledFloorBedRoom',
    TiledFloorHouseInterior = 'TiledFloorHouseInterior',
    TiledFloorKitchen = 'TiledFloorKitchen',
    TiledFloorLobyLounge = 'TiledFloorLobyLounge',
    TiledFloorRestaurant = 'TiledFloorRestaurant',
    TiledFloorRoom = 'TiledFloorRoom',
    ToyBox = 'ToyBox',
    TreatmentTable = 'TreatmentTable',
    Trolley = 'Trolley',
    TvUnit = 'TvUnit',
    VanityUnit = 'VanityUnit',
    Veranda = 'Veranda',
    WallDisplayCase = 'WallDisplayCase',
    WallLamp = 'WallLamp',
    Wallpaper = 'Wallpaper',
    WallStylingUnit = 'WallStylingUnit',
    Wardrobe = 'Wardrobe',
    WaxedConcreteFloor = 'WaxedConcreteFloor',
    WaxedConcreteFloorBathRoom = 'WaxedConcreteFloorBathRoom',
    WaxedConcreteFloorBedRoom = 'WaxedConcreteFloorBedRoom',
    WaxedConcreteFloorHouseInterior = 'WaxedConcreteFloorHouseInterior',
    WaxedConcreteFloorKitchen = 'WaxedConcreteFloorKitchen',
    WaxedConcreteFloorLobyLounge = 'WaxedConcreteFloorLobyLounge',
    WaxedConcreteFloorRestaurant = 'WaxedConcreteFloorRestaurant',
    WaxedConcreteFloorRoom = 'WaxedConcreteFloorRoom',
    WoodenDeck = 'WoodenDeck',
    WoodenSign = 'WoodenSign',
    WoodenWardrobe = 'WoodenWardrobe',
    WorkTop = 'WorkTop',
}

export default DesignProjectId;
